// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xlargeOnWide-superElipse-528f31bb","strokeWidth":"super-ellipse-skins-xlargeOnWide-strokeWidth-25068c39"};